import { ApiInstance } from '../..';

const API_BASE = '/api/turo-reservations';

export const importTuroReservations = (data: any[]) => {
    return ApiInstance.getInstance().post(`${API_BASE}/import`, data);
};

export const getTuroReservations = (
    page: number = 1,
    pageSize: number = 10,
    search: string = ''
) => {
    return ApiInstance.getInstance().get(`${API_BASE}/all`, {
        params: { page, pageSize, search: search.trim() || undefined },
    });
};

export const importReservationsToCars = () => {
    return ApiInstance.getInstance().post(`${API_BASE}/importToCars`);
};

export const deleteAllTuroReservations = () => {
    return ApiInstance.getInstance().delete(`${API_BASE}/deleteAll`);
};
